"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledCardHeader = exports.StyledCardFooter = exports.StyledCardBody = exports.StyledCard = void 0;

var _card = _interopRequireDefault(require("./card"));

var _card2 = require("./card.styles");

exports.StyledCard = _card2.StyledCard;
exports.StyledCardHeader = _card2.StyledCardHeader;
exports.StyledCardFooter = _card2.StyledCardFooter;
exports.StyledCardBody = _card2.StyledCardBody;

var _image = _interopRequireDefault(require("../image"));

_card.default.Header = _card2.StyledCardHeader;
_card.default.Body = _card2.StyledCardBody;
_card.default.Footer = _card2.StyledCardFooter;
_card.default.Image = _image.default;
var _default = _card.default;
exports.default = _default;